var map = {
	"./body/arm.png": "NLTh",
	"./body/body.png": "/cYT",
	"./body/ear.png": "WjMs",
	"./body/eye.png": "Yzhn",
	"./body/head.png": "NMdN",
	"./body/leg.png": "1fkp",
	"./body/mouth.png": "P5/6",
	"./body/nose.png": "ZDnO",
	"./category/agenda.png": "84jL",
	"./category/animal.png": "n9QU",
	"./category/art.png": "5FQ0",
	"./category/boat.png": "Cong",
	"./category/book.png": "EUgQ",
	"./category/box.png": "Z4Gs",
	"./category/car.png": "WeWI",
	"./category/christmas.png": "gtEP",
	"./category/cinema.png": "w1UD",
	"./category/city.png": "q+8+",
	"./category/cloth.png": "eU0H",
	"./category/expression.png": "PFNx",
	"./category/family.png": "zrW5",
	"./category/food.png": "tN4d",
	"./category/house.png": "yZlf",
	"./category/idea.png": "RxY+",
	"./category/job.png": "u/xD",
	"./category/litterature.png": "S+fg",
	"./category/man.png": "oAwK",
	"./category/music.png": "LAzK",
	"./category/nature.png": "r+XG",
	"./category/plane.png": "ejZf",
	"./category/sport.png": "NgxV",
	"./category/tool.png": "UMbO",
	"./category/toy.png": "fEXs",
	"./category/tv.png": "R2ls",
	"./category/woman.png": "9sz7",
	"./category/world.png": "aNvc",
	"./color/black.png": "xbA5",
	"./color/blue.png": "UOyS",
	"./color/brown.png": "emBs",
	"./color/green.png": "xAOe",
	"./color/grey.png": "lgFM",
	"./color/orange.png": "dhjL",
	"./color/pink.png": "jpaP",
	"./color/purple.png": "5B5g",
	"./color/red.png": "DOYh",
	"./color/transparent.png": "HC7U",
	"./color/white.png": "beL0",
	"./color/yellow.png": "TY1q",
	"./feature/death.png": "3/3j",
	"./feature/electronic.png": "Qfff",
	"./feature/famous.png": "2oaF",
	"./feature/fast.png": "DNOb",
	"./feature/fiction.png": "vj1B",
	"./feature/gear.png": "91Ck",
	"./feature/happy.png": "TY58",
	"./feature/harm.png": "HfL8",
	"./feature/heart.png": "TbgW",
	"./feature/king.png": "+8ai",
	"./feature/medic.png": "wyAq",
	"./feature/money.png": "QKHm",
	"./feature/old.png": "bOQJ",
	"./feature/religion.png": "G8rB",
	"./feature/sad.png": "IABv",
	"./feature/science.png": "2QbP",
	"./feature/shield.png": "GKUS",
	"./feature/slow.png": "hqep",
	"./feature/time.png": "XbWS",
	"./feature/young.png": "BLyf",
	"./matter/cold.png": "Zhq7",
	"./matter/earth.png": "A9SA",
	"./matter/fabric.png": "VAKh",
	"./matter/fire.png": "zNcI",
	"./matter/hot.png": "4PAa",
	"./matter/metal.png": "HjbQ",
	"./matter/night.png": "wgN2",
	"./matter/paper.png": "QcJe",
	"./matter/rock.png": "+1Fm",
	"./matter/storm.png": "M74M",
	"./matter/water.png": "hYIp",
	"./matter/wet.png": "CnMg",
	"./matter/wind.png": "yo86",
	"./matter/wood.png": "S2nQ",
	"./misc/cut.png": "UzMm",
	"./misc/decompose.png": "Gc6h",
	"./misc/grid.png": "vCW5",
	"./misc/inside.png": "KT3n",
	"./misc/invert.png": "jIEk",
	"./misc/one.png": "7Czo",
	"./misc/puzzle.png": "3++c",
	"./misc/zero.png": "0cIE",
	"./shape/circle.png": "AOPT",
	"./shape/cone.png": "Gy+x",
	"./shape/cross.png": "01SS",
	"./shape/cube.png": "9JKX",
	"./shape/curve.png": "twUn",
	"./shape/cylinder.png": "Wa7E",
	"./shape/hole.png": "JmYR",
	"./shape/lay.png": "bnXT",
	"./shape/line.png": "1Tha",
	"./shape/peak.png": "2kXM",
	"./shape/pyramid.png": "7Xme",
	"./shape/round.png": "YopX",
	"./shape/sphere.png": "OCP/",
	"./shape/square.png": "KUvh",
	"./shape/star.png": "Ld/l",
	"./shape/triangle.png": "REYE",
	"./shape/whirl.png": "MzlK",
	"./shape/winding.png": "lBMR",
	"./size/circular.png": "l63K",
	"./size/down.png": "jrPe",
	"./size/large.png": "2uQT",
	"./size/left.png": "hPRy",
	"./size/right.png": "qwKA",
	"./size/small.png": "ll6C",
	"./size/tall.png": "sqnU",
	"./size/thin.png": "rZB+",
	"./size/up.png": "9T1h"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "HGI3";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/cards ^\.\/.*\.png$
// module id = HGI3
// module chunks = 1